import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, Typography, Autocomplete } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";
import AssignDriver_VehicleService from "src/service/assigndriverService";
import DriverService from "src/service/driver";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import VehicleDetailsService from "src/service/vehicleDetails";
// import Select from 'react-select';

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Vehicle Assign to Driver ",
  },
];

const validationSchema = yup.object({
  driver_id: yup.string("driver name").required("driver name is required"),

  vehicle_no: yup
    .string("vehicle number")
    .required("vehicle number is required"),
});

const AssignVehicle_to_Driver = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  // get drivers list
  const [drivers, setDrivers] = useState([]);
  const [vehicle_list, setVehicle_list] = useState([]);

  const fetchDriversData = async () => {
    try {
      const res = await DriverService.getDriver({});
      setDrivers(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_vehicle_list = async () => {
    try {
      const res = await VehicleDetailsService.fetch_distict_vehicle({});

      setVehicle_list(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const initialValues = {
    driver_id: "",
    vehicle_no: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));
        try {
          const res = await AssignDriver_VehicleService.addAssignDriver(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/assignVehicleDriver");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  useEffect(() => {
    fetchDriversData();
    fetch_vehicle_list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  return (
    <div>
      <Breadcrumb title="Vehicle Assign to Driver" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Vehicle Assign to Driver
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/assignVehicleDriver");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            {/*   ==== assign driver name  -===  */}
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="fs-language">
                Driver <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <Autocomplete
                id="driver_id"
                name="driver_id"
                options={drivers}
                // getOptionLabel={(option) => option.driver_name}
                getOptionLabel={(option) =>
                  `${option.driver_name} - [Mobile No : ${option.driver_contact}]`
                }
                value={
                  drivers.find((driver) => driver.id === values.driver_id) ||
                  null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "driver_id", value: newValue?.id || "" },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={touched.driver_id && Boolean(errors.driver_id)}
                    helperText={touched.driver_id && errors.driver_id}
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a driver"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle Number <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_no"
                name="vehicle_no"
                options={vehicle_list}
                // getOptionLabel={(option) => option.vehicle_no}
                getOptionLabel={(option) => `${option.vehicle_no}`}
                value={
                  vehicle_list.find(
                    (vehicle_list) =>
                      vehicle_list.vehicle_no === values.vehicle_no
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "vehicle_no",
                      value: newValue?.vehicle_no || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                    helperText={touched.vehicle_no && errors.vehicle_no}
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a vehicle"
                  />
                )}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AssignVehicle_to_Driver;
